var _style, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoba(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#CCFF00;}\n\t.st2{fill:#1CD8D2;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 13.8,
    y: 1.9,
    width: 167,
    height: 66
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.2,47.3c-1.2,0-2.2-0.9-2.4-2.1L13.9,4.7c-0.1-0.7,0-1.3,0.4-1.8c0.4-0.5,1-0.9,1.6-1 c1.3-0.2,2.6,0.7,2.8,2l6.8,40.4c0.1,0.7,0,1.3-0.4,1.8c-0.4,0.5-1,0.9-1.6,1C23.4,47.3,23.3,47.3,23.2,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.7,28.6c-3.9,0-7.6,1.2-10.6,3.2l0.8,4.9c2.6-2.3,6-3.7,9.8-3.7c8.2,0,14.9,6.7,14.9,15 c0,8.2-6.7,15-14.9,15c-8.2,0-14.9-6.7-14.9-15c0-1.1,0.1-2.2,0.3-3.2L18.7,37c-2.1,3.1-3.4,6.9-3.4,11c0,10.7,8.7,19.4,19.3,19.4 S53.9,58.7,53.9,48S45.3,28.6,34.7,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.6,59.3c1.5,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6C31,58.1,32.2,59.3,33.6,59.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.8,56.2c1.5,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6 C39.2,55.1,40.4,56.2,41.8,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.4,50.6c1.5,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6 C32.7,49.4,33.9,50.6,35.4,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.2,53.3c1.5,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6 C24.6,52.1,25.7,53.3,27.2,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.5,47.9c1.5,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6S42,47.9,43.5,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.1,41.9c1.5,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6C34.5,40.7,35.7,41.9,37.1,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.9,44.9c1.5,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6C26.2,43.7,27.4,44.9,28.9,44.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoba);
export default __webpack_public_path__ + "static/media/boba.fed58f84d4b11f70c735a9873db7a35d.svg";
export { ForwardRef as ReactComponent };